import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faApple, 
  faGooglePlay 
} from '@fortawesome/free-brands-svg-icons';
import { 
  faChartLine, 
  faUtensils, 
  faClock 
} from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/images/logo.png';
import '../styles/components/homepage.css';
import { useTranslation } from 'react-i18next';

function HomePage() {
  const { t } = useTranslation();

  return (
    <div className="homepage">
      <section className="hero">
        <div className="hero-content">
          <h1>{t('homepage.hero.title')}</h1>
          <p>{t('homepage.hero.subtitle')}</p>
          <div className="app-downloads">
            <a href="#" className="app-button">
              <FontAwesomeIcon icon={faApple} className="store-icon" />
              <div className="button-text">
                <span className="button-small-text">{t('homepage.hero.downloadApp')}</span>
                <span className="button-large-text">AppStore</span>
              </div>
            </a>
            <a href="#" className="app-button">
              <FontAwesomeIcon icon={faGooglePlay} className="store-icon" />
              <div className="button-text">
                <span className="button-small-text">{t('homepage.hero.availableOn')}</span>
                <span className="button-large-text">GooglePlay</span>
              </div>
            </a>
          </div>
        </div>
        <div className="hero-image">
          <img src={logo} alt={t('homepage.hero.appImage')} />
        </div>
      </section>
      <section className="features-preview">
        <h2>{t('homepage.features.title')}</h2>
        <div className="feature-cards">
          <div className="feature-card">
            <div className="icon">
              <FontAwesomeIcon icon={faChartLine} />
            </div>
            <h3>{t('homepage.features.cards.glucose.title')}</h3>
            <p>{t('homepage.features.cards.glucose.description')}</p>
          </div>
          <div className="feature-card">
            <div className="icon">
              <FontAwesomeIcon icon={faUtensils} />
            </div>
            <h3>{t('homepage.features.cards.meals.title')}</h3>
            <p>{t('homepage.features.cards.meals.description')}</p>
          </div>
          <div className="feature-card">
            <div className="icon">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <h3>{t('homepage.features.cards.reminders.title')}</h3>
            <p>{t('homepage.features.cards.reminders.description')}</p>
          </div>
        </div>
        <Link to="/features" className="see-more-button">
          {t('homepage.features.seeMore')}
        </Link>
      </section>
    </div>
  );
}

export default HomePage;